export class ProtectionLevel {
	id: number;
	productId: number;
	level: string;
	pricingCardTypeId: number;
	startAmount: number;
	endAmount?: number | null;
	superhogUserId?: string | null;
	uiDisplayOrder: number;
	startDate: Date | string;
	endDate?: Date | string | null;
	createdDate: Date | string;
	updatedDate?: Date | string | null;
}
